// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__2rnrU","value":"Tag_value__1iqZa"};